module.exports = __webpack_public_path__ + "assets/img/two-tab7-on.3c246955.png";